<template>
  <div class="scroll_flex_container">
    <navbar title="門市訂單"></navbar>

    <div class="scroll_flex_container" style="width: 100%;">
      <ul v-infinite-scroll="load" :infinite-scroll-distance="100" :infinite-scroll-immediate="false"
        class="infinite-list"
        style="overflow-y: auto; overflow-x: hidden; width: 100%; padding: 0;-ms-overflow-style: none;scrollbar-width: none; margin: 0;">
        <div class="column_center_start" v-for="(group) in orderHistoryList" :key="group.date" style="width: 100%;">
          <div class="row_center_start w-full py-2.5 px-[3%]">
            <text class="order_date">{{ group.date }}</text>
          </div>
          <orderHistory v-for="(item) in group.list" :key="item.orderNumber" :item="item"></orderHistory>
        </div>
        <div v-if="!hasMore" class="row_center_center w-full px-[5%]"><el-divider
            style="border-top: 1px solid #AAAAAA; color: #AAAAAA;">沒有更多訂單</el-divider></div>
      </ul>
    </div>

  </div>
</template>
<script>
import navbar from "@/components/general/navbar.vue"
import commonUtils from "@/utils/common.utils";
import auth from "@/utils/auth.utils"
import { mapState, mapGetters } from 'vuex'
import orderHistory from '@/components/orderHistory/orderHistory.vue'
export default {
  components: {
    navbar,
    orderHistory
  },
  computed: {
    ...mapGetters('order', {
      orderHistoryList: 'sortedInStoreOrderHistoryWithMergedPriority',
      hasMore: 'hasMoreInStoreOrderHistory'
    }),
    ...mapState('basic', {
      currentStore: 'currentStore',
    }),
    ...mapGetters('userData', {
      isLogin: 'isLogin'
    })
  },
  async mounted() {
    if (!this.isLogin) {
      commonUtils.createToast("error", "登入狀態已過期，請重新登入");
      await commonUtils.delay(1500)
      auth.logout()
      this.$router.push({
        path: `/${this.currentStore}`
      })
      return
    }
    this.$store.commit('order/setInStoreOrderHistoryPage', 0)
    this.$store.commit('order/setInStoreOrderHistory', [])
    await this.load()
  },
  methods: {
    async load() {
      if (!this.hasMore) return
      try {
        commonUtils.createLoading("資料讀取中", "請稍後");
        await this.$store.dispatch('order/fetchInStoreOrderHistory')
        commonUtils.closeLoading();
      } catch (e) {
        console.log('fetch in store order history error', e)
        commonUtils.closeLoading();
        commonUtils.createToast('warning', e)
      }
    }
  },
};
</script>
<style lang="scss">
.order_date {
  color: #666666;
  font-size: 16px;
  font-weight: 500;
}

.order_history {
  width: 100%;
  padding: 15px 0;
  border-bottom: 1px dotted #999999;
  letter-spacing: 0.64px;
  margin-bottom: 10px;
  background-color: #fff;
}

.order_type {
  padding: 0 6px;
  border: 2px solid #FD4F02;
  color: #FD4F02;
  border-radius: 6px;
  font-size: 16px;
  height: 32px;
  font-weight: 500;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.order_type_refund {
  border-color: #AAAAAA;
  color: #AAAAAA;
}

.order_number {
  font-size: 20px;
  font-weight: 500;
  color: #000;
}

.order_time,
.pickup_time {
  color: #666666;
  font-size: 16px;
  font-weight: 400;
}

.order_item_list {
  width: 100%;
  margin-top: 10px;
}

.order_item {
  margin-bottom: 5px;
  font-size: 20px;
  font-weight: 400;
  color: #000;
  width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.product_name {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 95%;
}

.order_count {
  font-size: 20px;
  background-color: #cfcfcf;
  border-radius: 6px;
  min-width: 30px;
  padding: 0 5px;
  height: 30px;
  color: #000;
  margin-left: 10px;
  font-weight: 500;
}

.folded_order {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 400;
}

.payment_status {
  border-radius: 50px;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: 500;
  margin: 8px 4px 0 0;
  flex-shrink: 0;
}

.payment_status_pending {
  background-color: #AAAAAA;
  color: #fff;
}

.payment_status_yellow_bg {
  background-color: #FBCB02;
  color: #000;
}

.payment_status_linePay {
  background-color: #03BF5B;
  color: #fff;
}

.payment_status_refund {
  background-color: #AAAAAA;
  color: #fff;
}

.payment_status_red_border {
  background-color: transparent;
  color: #F50B53;
  border: 1px solid #F50B53;
}

.order_amount {
  font-size: 24px;
  font-weight: 500;
  color: #000;
}
</style>
